// extracted by mini-css-extract-plugin
export var icon = "_7l-1";
export var subtext = "_7l-0";